import { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';

import { useScreenContext } from 'navigation/context/ScreenContextProvider';
import { RouteNames } from 'navigation/linkingConfig';
import { AppActions } from 'store/App';
import { TAB_BARS } from 'store/App/constants';
import { useAppDispatch } from 'store/hooks';
import { OrderSelectors } from 'store/Orders';
import { OrderInternalStatuses } from 'store/Orders/enums';
import { getOrderInternalStatus } from 'store/Orders/utils';

import type { TabBarKey } from 'store/App/constants';

const OrderInternalStatusToTabBarKeyMap = {
  [OrderInternalStatuses.NOT_BEING_PREPARED]: TAB_BARS.new.value,
  [OrderInternalStatuses.BEING_PREPARED]: TAB_BARS.cooking.value,
  [OrderInternalStatuses.SCHEDULED]: TAB_BARS.scheduled.value,
  [OrderInternalStatuses.PREPARED]: TAB_BARS.prepared.value,
  [OrderInternalStatuses.CANCELLED]: TAB_BARS.prepared.value,
};

export function getCorrectTabForOrder(
  orderInternalStatus: OrderInternalStatuses,
): TabBarKey {
  return OrderInternalStatusToTabBarKeyMap[orderInternalStatus] as TabBarKey;
}

export function useNavigateToOrderDetails(orderUUID?: string) {
  const navigation = useNavigation();
  const { updateScreen } = useScreenContext();
  const dispatch = useAppDispatch();

  return useCallback(
    (overrideOrderUUID?: string) => {
      dispatch((action, getState) => {
        const state = getState();

        const order = OrderSelectors.selectById(
          state,
          overrideOrderUUID ?? orderUUID,
        );

        const items = order?.uuid
          ? OrderSelectors.selectItemsForOrderWithCategories(state, order.uuid)
          : undefined;

        if (!order || !items) {
          return;
        }
        navigation.navigate(RouteNames.Home.Main.Drawer._);
        updateScreen('overview');
        dispatch(AppActions.setSelectedOrderUUID({ orderUUID: order.uuid }));

        const orderInternalStatus = getOrderInternalStatus(order, items);

        const correctTabValue: TabBarKey =
          getCorrectTabForOrder(orderInternalStatus);

        action(AppActions.setTabBar({ value: correctTabValue }));
      });
    },
    [dispatch, orderUUID, navigation, updateScreen],
  );
}
